export default __webpack_public_path__ + "static/evening-aeefd4ecda68afbe017a230fe98c9e9d.webp";